import cookie from "react-cookie";
import objectAssign from "object-assign";
import phoneFormatter from "phone-formatter";
import _ from "lodash";
import { USER_MANAGER } from "../../constants/constants";

export const modifyFilter = (originalFilter, name, value) => {
  let filter = objectAssign({}, originalFilter);
  if (filter[name] !== value) {
    filter[name] = value;
    if (name !== "activePage") {
      filter.activePage = 1;
    }
    if (name === "resultsPerPage") {
      cookie.save("aw_results_per_page", value);
    } else if (name === "sortField") {
      cookie.save("aw_sort_field", value);
    }
    if (name === "bannerFilter" && value === "openHouses") {
      filter.sortField = "openhousedate";
    }
  }
  return filter;
};

export const loadCookie = function (name, validation, fallback) {
  let value = cookie.load(name);
  if (validation && validation.indexOf(value) === -1) {
    return fallback;
  }
  return value;
};

export const parsePage = function (props) {
  if (props.location && props.location.query && props.location.query.page) {
    return parseInt(props.location.query.page, 10);
  } else {
    return 1;
  }
};

export const parseBannerFilter = (props) => {
  if (
    props.location &&
    props.location.query &&
    props.location.query.bannerFilter
  ) {
    return props.location.query.bannerFilter;
  }
  return "all";
};

export const getSortField = (props, isGlobal = false) => {
  if (
    props.location &&
    props.location.query &&
    props.location.query.latitude &&
    props.location.query.longitude
  ) {
    return "distance";
  } else if (cookie.load("aw_sort_field")) {
    return cookie.load("aw_sort_field");
  } else {
    return isGlobal ? "price" : "currentPrice";
  }
};

export const generateCleanFilter = (originalFilter, defaults) => {
  let filter = {};
  objectAssign(filter, originalFilter);
  Object.keys(filter).forEach(function (key) {
    let filterItem = filter[key];
    if (filterItem instanceof Array && filterItem.length) {
      filter[key] = filter[key].join(exports.delimiter);
    } else if (filterItem === defaults[key]) {
      delete filter[key];
    }
  });
  delete filter.regionUrlParts;
  delete filter.listingType;
  delete filter.idxExclusions;

  return filter;
};

export const delimiter = "-";

export const showRentalPrices = (listing) => {
  return (
    listing &&
    listing.listingType === "rental" &&
    listing.rentalPrices &&
    listing.rentalPrices.length > 0 &&
    listing.displayPrice !== "Price Upon Request"
  );
};

export const listingSortOptions = [
  {
    value: "relevance",
    label: "relevance",
  },
  {
    value: "currentPrice",
    label: "price",
  },
  {
    value: "interior",
    label: "square feet",
  },
  {
    value: "totalBedrooms",
    label: "beds",
  },
  {
    value: "baths",
    label: "baths",
  },
];

export const parse = (data) => {
  let parsed = null;
  try {
    parsed = JSON.parse(data);
  } catch (e) {
    console.error(e);
  }
  return parsed;
};

export const sortFields = [
  { value: "currentPrice", label: "price" },
  { value: "interior", label: "square feet" },
  { value: "totalBedrooms", label: "beds" },
  { value: "baths", label: "baths" },
];

export const bannerOptions = [
  { value: "all", label: "all homes" },
  { value: "openHouses", label: "open houses" },
  { value: "contract", label: "in contract" },
  { value: "newListing", label: "recently listed" },
  { value: "hasVideos", label: "videos" },
];

export const formatPhone = (phone) => {
  return phone ? phoneFormatter.format(phone, "(NNN) NNN-NNNN") : "";
};

export const getAgentIds = (entity) => {
  if (entity.entityType === 2) {
    // for team
    return entity.teamMembers.map((m) => m.agentId.toString());
  }
  if (
    entity.salesTeamAgents &&
    entity.salesTeamAgents.length > 0 &&
    entity.salesTeam &&
    entity.salesTeam.canShareProperties
  ) {
    return entity.salesTeamAgents;
  }
  return entity.agentId;
};

export const findAndRemove = (array, key, value) => {
  if (!array || array.length === 0) {
    return array;
  } else {
    return array.filter((x) => x[key] !== value);
  }
};

export const singularListingType = (listingType) => {
  return !listingType
    ? "sale"
    : listingType.substring(0, listingType.length - 1);
};

export const listView = {
  outerClasses: "col-xs-16 list-item",
  innerClasses: "col-sm-8 col-xs-16",
};

export const photoView = {
  outerClasses: "col-sm-8 col-xs-16 photo-item",
  innerClasses: "col-xs-16",
};

export const photoViewConsider = {
  outerClasses: "col-sm-7 col-xs-14 photo-item",
  innerClasses: "col-xs-16",
};

export const getEntityToShow = (entity) => {
  if (entity.entityType === 2) {
    // return entity.TeamMembers[0];
    return entity; //todo show team for now
  } else {
    return entity;
  }
};

export const isScrolledIntoView = (el) => {
  const windowHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  const elemTop = el.getBoundingClientRect().top;
  const elemBottom = el.getBoundingClientRect().bottom;
  return (
    (elemTop > 0 && elemTop < windowHeight) ||
    (elemBottom > 0 && elemBottom < windowHeight)
  );
};

export const getContactButtonText = (entity) => {
  if (entity.entityType === 2) {
    return "Contact Us";
  } else {
    return "Contact Me";
  }
};

export const getEntityLabel = (entity) => {
  if (entity.entityType === 2) {
    return "Team";
  } else {
    return "Agent";
  }
};

export const getTitleBase = (entity) => {
  let offSalesRegion = entity.region.officeSalesRegion;
  //hardcode office sales region for Wine Country - Ice House Brokerage - SAM-36
  //altas officeId = 120
  if (entity.officeId === "2b428222-d748-43cc-8127-ce5e1a1e5086") {
    offSalesRegion = "Sonoma Wine Country";
  }
  const tagline = entity.tagline ? `${entity.tagline}, ` : "";
  return `${entity.displayName}, ${tagline}${offSalesRegion} Real Estate | ${entity.brand}, Inc.`;
};

export const getCorrectOffSalesRegion = (entity) => {
  let offSalesRegion = entity.region.officeSalesRegion;
  //hardcode office sales region for Wine Country - Ice House Brokerage - SAM-36
  //altas officeId = 120
  if (entity.officeId === "2b428222-d748-43cc-8127-ce5e1a1e5086") {
    offSalesRegion = "Sonoma Wine Country";
  }

  return offSalesRegion;
};

export const showFairHousingNotice = (entity) => {
  return ["nyc", "hamptons"].indexOf(entity.region.urlPart) !== -1;
};

const sellSideTypeId = 1;
const buySideTypeId = 2;

export const isBuySide = (entity, listing) => {
  const match =
    entity.entityType !== 2 &&
    _.find(listing.agents, (a) => parseInt(a.agentId, 10) === entity.agentId); //will have to update
  return (
    match &&
    _.isArray(match.sideTypeIds) &&
    match.sideTypeIds.indexOf(buySideTypeId) !== -1
  );
};

export const isSellSide = (entity, listing) => {
  const match =
    entity.entityType !== 2 &&
    _.find(listing.agents, (a) => parseInt(a.agentId, 10) === entity.agentId); //will have to update
  return (
    match &&
    _.isArray(match.sideTypeIds) &&
    match.sideTypeIds.indexOf(sellSideTypeId) !== -1
  );
};

export const splitAgentBySide = (agents) => {
  let agentSide = {
    both: [],
    seller: [],
    buyer: [],
  };
  const both = [1, 2];
  agents.forEach((agentData) => {
    if (_.isEqual(both, agentData.sideTypeIds)) {
      agentSide.both.push(agentData.name);
    } else if (_.includes(agentData.sideTypeIds, 1)) {
      agentSide.seller.push(agentData.name);
    } else if (_.includes(agentData.sideTypeIds, 2)) {
      agentSide.buyer.push(agentData.name);
    }
  });

  return agentSide;
};

export const updateOfficeSelect = (filter, agentType, entity) => {
  if (agentType === USER_MANAGER) {
    const { officeManagerDetails } = entity;
    filter = {
      ...filter,
      officeSelect: true,
      // check and update accordingly
      officeId: officeManagerDetails.map((off) => off.officeId),
      agentSelect: undefined,
      agentId: undefined,
    };
  }
  return filter;
};

export const getAgentInfo = (entity) => ({
  agentId: entity.agentId ? entity.agentId.toString() : "",
  name: entity.displayName,
  imageSrc: entity.hasPhoto && entity.photo.url,
  license: entity.license ? entity.license.replace("DRE#: ", "") : null,
  mobilePhone:
    entity.siteOptions.entityType === 2
      ? formatPhone(entity.primaryPhone)
      : formatPhone(entity.mobilePhone),
  officePhone: formatPhone(entity.workPhone || entity.office.phone),
  link: "/about",
  siteType: entity.siteOptions.entityType,
  title: entity.title,
});

export const isStagingSite = () =>
  ["agentid", "teamid"].some((x) => window.location.search.includes(x));

export const validate2AgentTeam = (entity) => {
  return (
    entity.entityType === 2 &&
    entity.phoneNoDisplayType === 2 &&
    entity.teamMembers &&
    entity.teamMembers.length === 2
  );
};

export const sortByCustomDisplayOrder = (teamMembers, teamMemberOptions) => {
  //removed custom logic option from cms
  // if (teamMemberOptions && teamMemberOptions.useCustomOrder) {
  //   let indexMap = {};
  //   teamMembers.forEach((m, i) => {
  //     indexMap[m.associateId] = i;
  //   });
  //   return teamMembers.slice().sort((a, b) => {
  //     let matchA = teamMemberOptions.customDisplayOrder.find(
  //       (c) => c.associateId === a.associateId
  //     );
  //     let matchB = teamMemberOptions.customDisplayOrder.find(
  //       (c) => c.associateId === b.associateId
  //     );
  //     return (
  //       (matchA ? matchA.displayOrder : indexMap[a.associateId]) -
  //       (matchB ? matchB.displayOrder : indexMap[b.associateId])
  //     );
  //   });
  // }

  return teamMembers;
};



// WEBPACK FOOTER //
// ./src/components/shared/util.js